import axios from 'axios';
import apis from '../../../app/apis';
import provideRecaptchaToken from './recaptchaToken';

const requestPin = async (formInput) => {
  const {
    method, email, sms, phone, areaCode: country_cd
  } = formInput;
  const token = await provideRecaptchaToken();
  let payload = { token };
  let urlPart;
  if (['sms', 'phone'].includes(method)) {
    const number = method === 'sms' ? sms : phone;
    payload = {
      ...payload, method, number, country_cd
    };
    urlPart = 'number';
  } else {
    payload = { ...payload, email };
    urlPart = 'email';
  }
  const { data: { success } } = await axios.post(`${apis.reminderSignUp}/verify-${urlPart}`, payload);
  return success;
};

export default requestPin;
